<app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
<nav class="subnav">
  <h2>Overview</h2>
</nav>

<div class="container container-inner">
  <div class="row">
    <div class="col-12 col-md-12">
      <div class="card mt-3 bg-dark text-white mb-3">
        <img
          src="/assets/img/module-iquit-470x260.jpg"
          class="card-img-top card-img-top-fh img-mobile"
          alt="Some snapping a cigarette"
        />
        <img
          src="/assets/img/module-iquit-930x260.jpg"
          class="card-img-top card-img-top-fh img-desktop"
          alt="Some snapping a cigarette"
        />
        <div class="card-body text-center">
          <h3 class="card-title card-title-lg">Quit Smoking For Surgery</h3>
          <p class="card-text">
            Welcome to i-Quit! The module that aims to help you stop smoking in
            preparation for surgery
          </p>
        </div>
      </div>
      <button
        class="btn btn-primary w-100"
        [routerLink]="['/modules', 'i-quit', 'tracker']"
      >
        Smoking Tracker
      </button>
    </div>
    <div class="col-12" *ngIf="userData">
      <h4 class="text-center mt-4 mb-2">Module Task List</h4>

      <div class="card bg-light">
        <div class="card-body">
          <ul class="link-list">
            <li>
              <a [routerLink]="['/modules', 'i-quit', 'resources']">
                <span class="circle-num">1</span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">Welcome to I-Quit</span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/modules', 'i-quit', 'resources', 15]">
                <span class="circle-num">2</span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">
                  Why it's important to stop smoking for surgery
                </span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/modules', 'i-quit', 'resources', 16]">
                <span class="circle-num">3</span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">
                  How to stop smoking for surgery
                </span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/modules', 'i-quit', 'resources', 17]">
                <span class="circle-num">4</span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label"
                  >How to record and monitor my i-Quit progress for
                  surgery</span
                >
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/modules', 'i-quit', 'tracker']">
                <span class="circle-num"
                  ><fa-icon [icon]="['far', 'repeat']"></fa-icon
                ></span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['far', 'smoking-ban']"></fa-icon
                ></span>
                <span class="link-label"
                  >Add Entries to the smoking tracker</span
                >
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a (click)="journalService.onShowJournal('iQuit')">
                <span class="circle-num"
                  ><fa-icon [icon]="['far', 'repeat']"></fa-icon
                ></span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'book']"></fa-icon
                ></span>
                <span class="link-label">I-Quit Journal</span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
